import { NOT_NUMBER } from "hooks/useZodErrorParse";
import { NUMBER_OR_EMPTY_STRING } from "resources/field-data/fieldValidationRegex";
import { z } from "zod";

export const scenarioCreateSchema = z.object({
  name: z.string().trim().nonempty(),
  frenchName: z.string().trim(),
  casestudyNumber: z.string().regex(NUMBER_OR_EMPTY_STRING, {
    message: NOT_NUMBER
  }),
  taxpayerName: z.string().trim(),
  level: z.string().trim().nonempty(),
  province: z.string().trim().nonempty(),
})

export type TCreateScenario = z.infer<typeof scenarioCreateSchema>

export const scenarioSchema = z.object({
  id: z.number(),
  name: z.string(),
  casestudyNumber: z.string(),
  level: z.string(),
  taxpayerName: z.string(),
  province: z.string(),
  vmId: z.number(),
  userVmId: z.number().nullable(),
  isReview: z.boolean().nullable(),
  userScenarioId: z.number().nullable(),
  submittedStatus: z.number().nullable(),
  frenchName: z.string().nullable(),
  isPublished:z.boolean()
})

export const scenariosSchema = scenarioSchema.array()
export type TScenarios = z.infer<typeof scenariosSchema>
export type TScenario = z.infer<typeof scenarioSchema>

export const submitResponseSchema = z.object({
  id: z.number(),
  scenarioId: z.number(),
  vmId: z.number(),
  submitStatus: z.union([z.literal(0), z.literal(1)])
})

export type TSubmitResponse = z.infer<typeof submitResponseSchema>

export const DeletePracticeResponse = z.object({
  createdBy : z.string(),
  createdDate: z.string(),
  id: z.number(),
  isDeleted : z.boolean(),
  updatedBy: z.string(),
  updatedDate: z.string(),
  userId: z.string(),
  vmId: z.string()
});

export type TDeletePracticeResponse = z.infer<typeof DeletePracticeResponse>

export const publishScenrioDetails = z.object(

  {
    id: z.number(),
    scenarioName: z.string(),
    level: z.string(),
    province: z.string(),
    isPublished: z.boolean(),
    vmId: z.number(),
    isDeleted: z.boolean(),
    frenchName: z.string(),
    casestudyNumber: z.string(),
    taxpayerName: z.string(),
    createdDate:z.string(),
    updatedDate: z.string(),
    createdBy: z.string(),
    updatedBy: z.string()
}
);

export type TPublishScenario = z.infer<typeof publishScenrioDetails>